import { useEffect, useRef } from 'react';
import { useKSK1080_R01Store } from './Store_KSK1080_R01';
import { Content_KSK1080_R01 } from './Content_KSK1080_R01';
import { SearchSection_KSK1080_R01 } from './SearchSection_KSK1080_R01';
import { Table_KSK1080_R01 } from './Table_KSK1080_R01';
import Actionbar from 'src/components/common/actionbar/Authactionbar';
import { Message } from 'src/components/common/form/Message';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import useUiuxStore from 'src/store/useUiuxStore';

export const Container_KSK1080_R01 = () => {
    const { 
        initData, 
        activeTab, 
        tabData 
    } = useKSK1080_R01Store();

    const { setMessage } = useUiuxStore();

    const { fetchData, handleExcelClick, handleTabChange, columns, data } = Content_KSK1080_R01({
        setMessage
    });

    const gridRef = useRef<any>(null);

    // 권한 체크
    useFetchActionbarAuth('KSK1080_R01');

    return (
        <div className="content-container">
            <Actionbar
                onFetchClick={fetchData}
                onExcelClick={handleExcelClick}
                onCreateClick={() => {}}
                onDeleteClick={() => {}}
                onSaveClick={() => {}}
                onInitClick={initData}
            />
            <SearchSection_KSK1080_R01 />
            <div className="flex-1 flex">
                <div className="w-full h-full flex flex-col p-[12px] gap-[12px]">
                    <Table_KSK1080_R01
                        gridRef={gridRef}
                        tabType={activeTab}
                        data={data}
                        columns={columns}
                        onTabChange={handleTabChange}
                    />
                </div>
            </div>
        </div>
    );
};
